import m from "../../geodata/es2015/spainProvincesHigh";
window.am4geodata_spainProvincesHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/spainProvincesHigh.js
// module id = null
// module chunks = 